import React from 'react';
import { cn } from '~/shared/components/utils';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';

export function VisitBucketItemWrapper({
	className,
	footerSlot,
	children
}: {
	className?: string;
	footerSlot?: React.ReactNode;
	children: React.ReactNode;
}) {
	return (
		<div id="visit-bucket-item-wrapper" className={cn('absolute inset-0', className)}>
			<div className="absolute inset-0 bottom-[65px] overflow-y-auto">
				<div className="mx-auto p-8">{children}</div>
			</div>
			<FooterButtonContainer className="absolute inset-x-0 bottom-0 z-20 flex h-[65px] justify-between border-t bg-white p-4">
				{footerSlot}
			</FooterButtonContainer>
		</div>
	);
}
